import i18n from 'i18next'

export enum EventType {
  AppointmentCreated = 1,
  AppointmentUpdated,
  AppointmentCancelled,

  FormSubmitted,
  FormCompleted,

  ResourceShared,
  ResourceUpdated,

  ArticlePublished,
  ArticleUpdated,

  TrainingAssigned,
  TrainingCompleted,

  CalendarEventCreated,
  CalendarEventReminder,
}

export const eventType = (): Record<EventType, string> => ({
  [EventType.AppointmentCreated]: i18n.t('appointmentCreated'),
  [EventType.AppointmentUpdated]: i18n.t('appointmentUpdated'),
  [EventType.AppointmentCancelled]: i18n.t('appointmentCancelled'),
  [EventType.FormSubmitted]: i18n.t('formSubmitted'),
  [EventType.FormCompleted]: i18n.t('formCompleted'),
  [EventType.ResourceShared]: i18n.t('resourceShared'),
  [EventType.ResourceUpdated]: i18n.t('resourceUpdated'),
  [EventType.ArticlePublished]: i18n.t('articlePublished'),
  [EventType.ArticleUpdated]: i18n.t('articleUpdated'),
  [EventType.TrainingAssigned]: i18n.t('trainingAssigned'),
  [EventType.TrainingCompleted]: i18n.t('trainingCompleted'),
  [EventType.CalendarEventCreated]: i18n.t('calendarEventCreated'),
  [EventType.CalendarEventReminder]: i18n.t('calendarEventReminder'),
})
